var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ui form" }, [
    _c(
      "div",
      {
        staticClass: "fields",
        class: ((_obj = {}), (_obj[_vm.formType] = true), _obj)
      },
      [
        _vm._t("default"),
        _vm._v(" "),
        _vm._l(_vm.options, function(option) {
          return _c("div", { key: option.value, staticClass: "field" }, [
            _c("div", { class: _vm.radioButtonClasses }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.radioValue,
                    expression: "radioValue"
                  }
                ],
                attrs: {
                  type: "radio",
                  name: _vm.name,
                  disabled: _vm.disabled
                },
                domProps: {
                  value: option.value,
                  checked: _vm._q(_vm.radioValue, option.value)
                },
                on: {
                  change: function($event) {
                    _vm.radioValue = option.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  on: {
                    click: function($event) {
                      return _vm.toggle(option.value)
                    }
                  }
                },
                [_vm._v(_vm._s(option.label))]
              )
            ])
          ])
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68f54725", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68f54725","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/croud-vue-semantic/src/Radiobutton.vue
// module id = MFh9
// module chunks = 1